function transformHelper(transform, radarPos, northPos) {
  const newRadarPos = to360(radarPos);
  const newNorthPos = to360(northPos);
  const offset = newRadarPos + 360 - newNorthPos;
  const angle = offset > 360 ? offset - 360 : offset;

  if (!transform.includes('rotateZ')) {
    return `${transform} rotateZ(${angle}deg)`;
  } else {
    const i = transform.indexOf('rotateZ');
    const sub = transform.substring(0, i);
    return `${sub} rotateZ(${angle}deg)`;
  }
}

function to360(deg) {
  if (deg < 0) {
    return Math.abs(deg) + 180;
  } else {
    return 180 - deg;
  }
}

export { transformHelper, to360 };
